export default __webpack_public_path__ + "static/media/12.2f5d8e6d.jpg";